// Public overview only. This is the owner's deployed branded destination.
// Public overview publication is gated on normal-browser entry checks in
// docs/courses-public/access-boundary.json and scripts/courses/check-release.mjs.
// Never place private course data, reviewer identities or entitlements here.
export const coursesAccess: { signInUrl: string | null } = {
  signInUrl: "https://courses.bharatheeya.org/courses/",
};

export const courseLanguages = [
  "Sanskrit", "English", "Hindi", "Tamil",
  "Telugu", "Kannada", "Gujarati", "Malayalam",
] as const;
